// extracted by mini-css-extract-plugin
module.exports = {"simpleBlock":"simpleBlock__J4kQ5"};